module.exports = __webpack_public_path__ + "img/logo.76d0d8bf.png";